export const KRP_BUSINESS = {
  name: "Kitchen Renovations Perfected",
  shortName: "KRP",
  tagline: "South Florida\u2019s Trusted Experts in Kitchen & Bath Design",
  phone: "(561) 441-6008",
  email: "elliott@kitchenrp.com",
  address: "5250 Town Center Cir #109",
  city: "Boca Raton",
  state: "FL",
  zip: "33486",
  fullAddress: "5250 Town Center Cir #109, Boca Raton, FL 33486",
  hours: "Mon\u2013Fri: 10:00 AM \u2013 5:00 PM",
  rating: 4.9,
  reviewCount: 150,
  packageStart: "$9,995",
};

export const KRP_SERVICES = [
  {
    id: "kitchen-remodeling",
    title: "Kitchen Remodeling",
    description: "Complete design-build kitchen transformations featuring custom cabinetry, premium countertops, and chef-inspired layouts tailored to your lifestyle.",
    icon: "ri-knife-line",
    image: "https://public.readdy.ai/ai/img_res/8be7653b826d090da1350fdaad2d3463.jpg",
  },
  {
    id: "bathroom-renovations",
    title: "Bathroom Renovations",
    description: "Spa-inspired bathroom remodels with designer tile, custom vanities, and luxurious fixtures that bring five-star hospitality into your home.",
    icon: "ri-hotel-line",
    image: "https://readdy.ai/api/search-image?query=luxury%20spa%20bathroom%20renovation%20marble%20tile%20freestanding%20tub%20designer%20vanity%20warm%20lighting%20South%20Florida%20home%20premium%20interior%20design%20editorial%20photography%20high%20end%20residential%20minimalist%20clean&width=800&height=600&seq=102&orientation=landscape",
  },
  {
    id: "custom-cabinetry",
    title: "Custom Cabinetry",
    description: "Precision-crafted cabinets built to your exact specifications. From shaker to contemporary, every door, drawer, and detail is engineered for perfection.",
    icon: "ri-layout-2-line",
    image: "https://readdy.ai/api/search-image?query=custom%20premium%20kitchen%20cabinetry%20white%20shaker%20doors%20soft%20close%20hardware%20beautiful%20grain%20wood%20finish%20professional%20interior%20photography%20warm%20neutral%20background%20luxury%20craftsmanship%20Boca%20Raton%20home%20editorial&width=800&height=600&seq=103&orientation=landscape",
  },
  {
    id: "outdoor-kitchens",
    title: "Outdoor Kitchens",
    description: "Bring the culinary experience outside with fully equipped outdoor kitchen designs built for Florida\u2019s year-round entertaining lifestyle.",
    icon: "ri-sun-line",
    image: "https://readdy.ai/api/search-image?query=luxury%20outdoor%20kitchen%20South%20Florida%20backyard%20built%20in%20grill%20marble%20countertop%20modern%20design%20palm%20trees%20tropical%20setting%20high%20end%20residential%20professional%20photography%20editorial%20warm%20evening%20light&width=800&height=600&seq=104&orientation=landscape",
  },
  {
    id: "closet-design",
    title: "Custom Closets",
    description: "Thoughtfully designed walk-in closets and storage solutions that combine functionality with the refined aesthetics your home deserves.",
    icon: "ri-archive-line",
    image: "https://readdy.ai/api/search-image?query=luxury%20custom%20walk%20in%20closet%20white%20built%20in%20shelving%20organized%20wardrobe%20South%20Florida%20home%20professional%20interior%20photography%20warm%20lighting%20high%20end%20residential%20clean%20minimal%20editorial%20style&width=800&height=600&seq=105&orientation=landscape",
  },
  {
    id: "flooring",
    title: "Premium Flooring",
    description: "Wide-plank hardwood, large-format porcelain, and luxury tile installations that anchor the entire aesthetic of your redesigned space.",
    icon: "ri-layout-bottom-2-line",
    image: "https://readdy.ai/api/search-image?query=luxury%20large%20format%20porcelain%20tile%20flooring%20installation%20kitchen%20living%20area%20South%20Florida%20home%20professional%20interior%20photography%20warm%20neutral%20tones%20high%20end%20residential%20editorial%20clean%20minimal&width=800&height=600&seq=106&orientation=landscape",
  },
];

export const KRP_SERVICE_AREAS = [
  "Boca Raton",
  "Delray Beach",
  "Palm Beach Gardens",
  "Wellington",
  "Boynton Beach",
  "Lake Worth",
  "West Palm Beach",
  "Jupiter",
  "Fort Lauderdale",
  "Pompano Beach",
  "Coral Springs",
  "Parkland",
  "Deerfield Beach",
  "Highland Beach",
  "Lantana",
];

export const KRP_TESTIMONIALS = [
  {
    id: 1,
    name: "Sandra M.",
    location: "Boca Raton, FL",
    rating: 5,
    text: "Working with KRP was an absolute dream. Their design team created 3D renderings that perfectly captured our vision before a single cabinet was ordered. The final result is stunning\u2014we get compliments every time someone visits.",
    project: "Kitchen Remodel",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20middle%20aged%20woman%20friendly%20smile%20South%20Florida%20homeowner%20neutral%20clean%20background%20warm%20lighting%20portrait%20photography&width=200&height=200&seq=201&orientation=squarish",
  },
  {
    id: 2,
    name: "Robert & Diane K.",
    location: "Delray Beach, FL",
    rating: 5,
    text: "From the first consultation to the final walkthrough, the KRP team was professional, communicative, and truly talented. Our kitchen renovation exceeded every expectation. This family-owned company genuinely cares about quality.",
    project: "Full Kitchen & Bath Renovation",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20couple%20middle%20aged%20friendly%20smile%20Florida%20homeowners%20neutral%20clean%20background%20warm%20lighting%20portrait%20photography&width=200&height=200&seq=202&orientation=squarish",
  },
  {
    id: 3,
    name: "Jennifer L.",
    location: "Palm Beach Gardens, FL",
    rating: 5,
    text: "The custom cabinetry KRP installed is simply beautiful. They used premium Fabuwood cabinetry and the craftsmanship is impeccable. Our kitchen feels like it belongs in a magazine spread. Worth every penny.",
    project: "Custom Cabinetry & Countertops",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20woman%2040s%20friendly%20warm%20smile%20Florida%20resident%20neutral%20background%20soft%20lighting%20portrait%20photography&width=200&height=200&seq=203&orientation=squarish",
  },
  {
    id: 4,
    name: "Michael T.",
    location: "Wellington, FL",
    rating: 5,
    text: "I had three quotes before choosing KRP. Not only were they competitively priced, but their design expertise was in a completely different league. Our new kitchen has become the heart of our home.",
    project: "Kitchen Remodel",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20man%2050s%20friendly%20confident%20smile%20Florida%20homeowner%20neutral%20background%20warm%20lighting%20portrait%20photography&width=200&height=200&seq=204&orientation=squarish",
  },
  {
    id: 5,
    name: "Carol &amp; James W.",
    location: "Coral Springs, FL",
    rating: 5,
    text: "KRP transformed our outdated bathroom into a luxury spa retreat. Their attention to detail is extraordinary\u2014every tile is perfectly placed, every fixture is exactly right. We couldn\u2019t be more satisfied.",
    project: "Master Bathroom Renovation",
    avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20senior%20couple%20warm%20smile%20Florida%20homeowners%20clean%20neutral%20background%20soft%20lighting%20portrait%20photography&width=200&height=200&seq=205&orientation=squarish",
  },
];

export const KRP_PROCESS = [
  {
    step: "01",
    title: "Design Consultation",
    description: "We begin with a complimentary in-home or showroom consultation to understand your vision, assess your space, and discuss your investment range. No pressure, just possibilities.",
    icon: "ri-discuss-line",
  },
  {
    step: "02",
    title: "Custom 3D Design",
    description: "Our design team creates detailed 3D renderings of your new space so you can see exactly how your renovation will look before any work begins. Every detail is yours to approve.",
    icon: "ri-computer-line",
  },
  {
    step: "03",
    title: "Material Selection",
    description: "Visit our Boca Raton showroom to hand-select cabinets, countertops, tile, and fixtures from our curated collection of premium materials and trusted brands.",
    icon: "ri-palette-line",
  },
  {
    step: "04",
    title: "Expert Installation",
    description: "Our skilled craftsmen handle every aspect of your renovation with precision and care. We manage the entire project timeline, keeping you informed at every stage.",
    icon: "ri-tools-line",
  },
  {
    step: "05",
    title: "Final Walkthrough",
    description: "Before we consider the project complete, we conduct a thorough walkthrough together to ensure everything meets our exacting standards and your complete satisfaction.",
    icon: "ri-checkbox-circle-line",
  },
];

export const KRP_WHY_CHOOSE = [
  {
    icon: "ri-home-heart-line",
    title: "Family-Owned Excellence",
    description: "As a family-owned design-build firm, we treat every project as if it were our own home. That personal investment shows in every detail of our work.",
  },
  {
    icon: "ri-medal-2-line",
    title: "4.9-Star Rated",
    description: "With a 4.9-star rating across 150+ verified reviews, our reputation is built on consistent quality, clear communication, and results that exceed expectations.",
  },
  {
    icon: "ri-draft-line",
    title: "3D Design Visualization",
    description: "See your renovation before it begins. Our advanced 3D rendering technology lets you visualize and refine your space until it\u2019s perfect.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Licensed & Insured",
    description: "Fully licensed, bonded, and insured for your complete peace of mind. We handle all permits and inspections so you never have to worry.",
  },
  {
    icon: "ri-building-2-line",
    title: "Premium Brands",
    description: "We work exclusively with trusted names including Fabuwood cabinetry, premium countertop suppliers, and top-tier fixture brands for lasting quality.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Local South Florida Experts",
    description: "Rooted in Boca Raton, we understand South Florida\u2019s unique architecture, climate, and lifestyle. Our designs are built for how you actually live.",
  },
];
